import React from "react";
import "./PubMedQueryForm.css";
import Modal from "react-modal";
import "./BrainstormComponent.css";
import logo from "../assets/images/pubmed-logo.png";

interface PubMedQueryFormProps {
  isOpen: boolean;
  onRequestClose: () => void;
  pubMedTopic: string;
  setPubMedTopic: (topic: string) => void;
  handlePubMedQuery: () => void;
}

const PubMedQueryForm: React.FC<PubMedQueryFormProps> = ({
  isOpen,
  onRequestClose,
  pubMedTopic,
  setPubMedTopic,
  handlePubMedQuery,
}) => {
  const customStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.6)",
    },
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      width: "50%",
      height: "65%",
      borderRadius: "10px",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "#fff",
    },
  };

  return (
    <Modal
      isOpen={isOpen}
      style={customStyles}
      onRequestClose={onRequestClose}
      contentLabel="PubMed Query Modal"
    >
      <div className="pubmed-query-modal-content">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "5px",
            marginBottom: "-5px",
          }}
        >
          <img
            src={logo}
            alt="PubMed Logo"
            style={{ height: "50px", marginRight: "10px" }}
          />
          {/* <div className="pubmed-query-title">PubMed</div> */}
        </div>
        <label className="pubmed-query-label">
          Ask PubMed about your topic of interest:
        </label>
        <textarea
          className="pubmed-query-modal-input"
          placeholder="Enter topic here..."
          value={pubMedTopic}
          onChange={(e) => setPubMedTopic(e.target.value)}
          rows={5}
        />
        <div className="pubmed-buttons">
          <button className="modal-button-left" onClick={handlePubMedQuery}>
            Query
          </button>
          <button className="modal-button-left" onClick={onRequestClose}>
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default PubMedQueryForm;
